<template>
  <div class="spl-linehaulRoad-list-table">
    <table v-if="!isLoading">
      <thead>
        <tr class="spl-linehaulRoad-table__head">
          <th
            v-for="(header, index) in tableFields"
            :key="'dashboardPrecariageHeader' + index"
            @click="toggleSort(header.name)">
            <span
              v-if="findSort(sortedFields, header.name)"
              :class="findSort(sortedFields, header.name).direction"
              class="order-arrow" />
            {{ header.label }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(linehaulRoad, linehaulRoadIndex) in linehaulRoadList" :key="'linehaulRoadTable' + linehaulRoadIndex">
          <td
            v-for="(field, fieldIndex) in tableFields"
            :key="'dashboardPrecariageField' + linehaulRoadIndex + '.' + fieldIndex"
            :class="{'spl-linehaulRoad-table__field--number': isNumber(linehaulRoad[field.name])}"
            @click="linehaulRoadSelected(linehaulRoad)">
            <span>
              {{ formatField(linehaulRoad[field.name], field.type) }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="isLoading" class="spl-load-img" />
  </div>
</template>

<script lang="ts">
import { mapActions, mapGetters } from 'vuex'
import { find, findIndex, isNumber, filter } from 'lodash'
import { LinehaulRoadListItem } from '@/webApi/DataModels'
import constants from '@/constants'
import Helpers from '@/helpers.vue'
export default {
  mixins: [Helpers],
  data () {
    return {
      tableFields: [
        { name: 'Linehaul_Drive_Name', label: 'Drive Name', type: 'String' },
        { name: 'Linehaul_Drive_Detail_Customers', label: 'No. of Customers', type: 'Number' },
        { name: 'Linehaul_Drive_Detail_Parcels', label: 'No. of Parcels', type: 'Number' },
        { name: 'Linehaul_Drive_Detail_Weight', label: 'Weight', type: 'Number.2' },
        { name: 'Linehaul_Drive_Detail_Load_Meters', label: 'Load meters', type: 'Number' },
        { name: 'Linehaul_Drive_Detail_T1', label: 'T1', type: 'Number' },
        { name: 'Linehaul_Drive_Detail_Stops', label: 'No. of Stops', type: 'Number' },
        { name: 'Linehaul_Drive_Detail_Date', label: 'Date', type: 'Date' }
      ],
      sortedFields: [],
      isLoading: false
    }
  },
  computed: {
    ...mapGetters('linehaulRoad', ['linehaulRoadList'])
  },
  methods: {
    ...mapActions('linehaulRoad', ['sortList']),
    toggleSort (field) {
      // Finds the sorted field in the array
      var sortedField:any = find(this.sortedFields, { field: field })
      if (sortedField) {
        // Switches to desc when asc already selected
        if (sortedField.direction === 'asc') {
          sortedField.direction = 'desc'
        } else {
          // removes the sorting when desc was selected
          this.sortedFields.splice(findIndex(this.sortedFields, { field: field }))
        }
      } else {
        // adds the field when not yet present
        this.sortedFields.push({ direction: 'asc', field: field })
      }
      this.sortData()
    },
    linehaulRoadSelected (linehaulRoad:LinehaulRoadListItem) {
      this.$router.push('linehaul-road-edit/'+ linehaulRoad.Linehaul_Drive_Detail_ID)
    },
    // Sorting the data
    sortData () {
      // Sort fields and directions seperate for lodash orderBy method
      let sortFields = []
      let sortDirections = []
      // Create the sort fields
      for (let i = 0; i < this.sortedFields.length; i++) {
        const sortElement = this.sortedFields[i]
        sortFields.push(sortElement.field)
        sortDirections.push(sortElement.direction)
      }
      // Default sorting depending on grouping
      if (sortFields.length === 0) {
        sortFields = [constants.FILTER_NAMES.COUNTRY]
        sortDirections = ['asc']
      }
      // Use the lodash orderBy method for sorting
      this.sortList({ sortFields, sortDirections })
    },
    // Special formatting for fields
    formatField (field, type) {
      if (type === 'Date') {
        return this.formatDate(field, false, 'YYYY-MM-DD')
      } else if (type === 'Time') {
        return this.formatDate(field, true, 'YYYY-MM-DD HH:mm')
      } else if (type === 'Number.2') {
        return this.numberFormat(field, 2, false)
      }
      // empty fields will be removed
      if (field == null || field === 0) {
        return ''
      }
      return field
    },
    // find the right sort value for displaying arrows
    findSort (array, value) {
      return find(array, { field: value })
    },
    // including of helper since lodash not available in vue template
    isNumber (value) {
      return isNumber(value)
    }
  }

}
</script>

<style lang="scss">
  @import '../../../variables.scss';
  .spl-linehaulRoad-list-table {
    margin: 0 70px;
    width: calc(100% - 138px);

    table {
      border-spacing: 0;
      table-layout: fixed;
      padding-bottom: 20px;
    }
    &__head {
      th {
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 3px 5px 0 rgba(0, 0, 0, 0.1);
      }
      &--sticky {
        position: sticky;
        left: 41px;
        z-index: 3 !important;
      }
      &--checkbox {
        .spl-checkbox {
          margin: 10px 2px 0 6px;
        }
        position: sticky;
        left: 0px;
        z-index: 3 !important;
      }
    }
    &__row {
      &--selected {
        background-color: $tableRowBackgroundColorSelected !important;
      }
      &--deleted {
        opacity: 0.3;
        background-color: lightgrey !important;
      }
    }
    &__field {
      &--number {
        text-align: right;
        width: 70px;
      }
      &--sticky {
        position: sticky;
        left: 41px;
        box-shadow: 3px 0px 3px 0px rgba(0, 0, 0, 0.2);
        background-color: $tableHeaderBackgroundColor;
      }
      &--checkbox {
        .spl-checkbox {
          margin: 0 2px 0 6px;
        }
        position: sticky;
        background-color: $tableHeaderBackgroundColor;
        left: 0;
      }
      &--long {
        max-width: 400px !important;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      &--success {
        border-bottom: 2px solid $green !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $green;
      }
      &--warning {
        border-bottom: 2px solid $darkYellow !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $darkYellow;
      }
      &--error {
        border-bottom: 2px solid $red !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $red;
      }
      &--bold {
        font-weight: 600;
      }
      &--empty:hover {
        background-color: $tableRowBackgroundColorHover !important;
      }
    }
    thead {
      th {
        position: sticky;
        top: 0;
        text-align: center;
        font-family: $mono;
        font-size: 9px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 1px;
        line-height: 12px;
        background-color: $tableHeaderBackgroundColor;
        padding: 0px 5px  0px 5px;
        height: 40px;
        border-bottom: 1px solid $tableHeaderBorderColor;
      }

      th:hover {
        background-color: $tableColumnBackgroundColorHover;
        cursor: pointer;
      }
    }
    tbody {

      tr {
        background-color: $tableRowBackgroundColor;
      }

      tr:hover {
        background-color: $tableRowBackgroundColorHover;
      }

      td {
        border-style: solid;
        border-width: 0 1px 1px 0;
        border-color: $tableRowBorderLowColor;
        border-bottom-color: $tableRowBorderColor;
        font-size: 12px;
        padding: 5px;
        padding-top: 8px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 150px;
      }

      td:hover {
        background-color: $tableColumnBackgroundColorHover;
        cursor: pointer;
      }

      td:first-child {
        border-left-width: 1px;
      }
    }
}
</style>
